import {USER_ROLE_GUEST} from '../constants/roles'
import jwtDecode from 'jwt-decode'
import MUT from '../constants/vuexMutations'
import moment from '../moment'
import { SIGNIN_AFTER_HANDLER } from '../constants/graphql'
import apolloClient from '../apolloClient'

const checkUserActivityTime = 5 * 1000
const maxReachedNullEventsCount = 30

const userInfo = {
  install (Vue, options) {
    function Control () {
      this.jwt = null
      this.jwtParsed = null
      this.store = options.store
      this.identifyUserRole()
      this.lastTime = moment()
      this.eventNullCount = 0
      this.isOnline = null
    }
    Control.prototype.login = function (jwt) {
      localStorage.setItem('jwt', jwt)
      this.identifyUserRole()
    }
    Control.prototype.logout = function () {
      this.setStatus(false)
      this.eventNullCount = 0
      this.isOnline = null
      this.jwtParsed = null
      localStorage.removeItem('jwt')
      this.identifyUserRole()
    }
    Control.prototype.validateRelevanceToken = function () {
      if (this.jwt && this.jwtParsed) {
        if (!this._checkRelevanceToken(this.jwtParsed)) {
          this.logout()
        }
      }
    }
    Control.prototype.userTriggered = function (event) {
      this.eventNullCount = 0
    }
    Control.prototype.checkUserActivity = function () {
      if (this.jwt && this.jwtParsed && this.eventNullCount < maxReachedNullEventsCount) {
        if (moment().diff(moment(this.lastTime)) > checkUserActivityTime) {
          let role = this.jwtParsed.role
          if (role === 'logistician') {
            apolloClient.mutate({
              mutation: SIGNIN_AFTER_HANDLER
            })
          }
          this.isOnline = true
          this.lastTime = moment()
          this.eventNullCount++
          if (this.isOnline !== true) {
            this.setStatus(true)
          }
        }
      } else {
        if (this.isOnline === true) {
          this.setStatus(false)
        }
      }
    }
    Control.prototype.setStatus = function (status) {
      let token = localStorage.getItem('jwt')
      let jwtParsed = Control.prototype._decodeToken(token)
      this.isOnline = status
      this.store.commit(MUT.SET_USER_STATUS, {id: this.jwtParsed.user_id, status: status, lastTime: this.lastTime})
    }
    Control.prototype.identifyUserRole = function () {
      let token = localStorage.getItem('jwt')
      if (token) {
        let jwtParsed = Control.prototype._decodeToken(token)
        if (jwtParsed !== null) {
          Vue.prototype.$user.set({role: jwtParsed.role})
          this.jwt = token
          this.jwtParsed = jwtParsed
        } else {
          this.cleanToken()
        }
      } else {
        this.cleanToken()
      }
      this.store.commit(MUT.SET_JWT_PARSED, this.jwtParsed)
    }
    Control.prototype.cleanToken = function () {
      this.jwt = null
      this.jwtParsed = null
      Vue.prototype.$user.set({role: USER_ROLE_GUEST})
    }
    Control.prototype._decodeToken = function (token) {
      let jwtParsed = null
      try {
        jwtParsed = jwtDecode(token)
        let isTokenRelevance = this._checkRelevanceToken(jwtParsed)
        if (isTokenRelevance) {
          return jwtParsed
        }
      } catch (e) {
        console.error(e)
        console.error('Invalid jwt token')
      }
      return null
    }
    Control.prototype._checkRelevanceToken = function (tokenParsed) {
      return tokenParsed.exp > moment().unix()
    }
    Vue.prototype.$userControl = new Control()
  }
}

export default userInfo



// WEBPACK FOOTER //
// ./src/plugins/userInfo.js